module.exports = __webpack_public_path__ + "img/pwa-logo.d5c539d0.svg";